import { BrandBgEntity, RoomId, roomId } from "@common/domain";
import { JsonSchemaValidator } from "@common/json-schema-validator";

export class RoomBrandBgSetEventDTO {
  private static validation = JsonSchemaValidator.compile(
    RoomBrandBgSetEventDTO.validationSchema(),
    BrandBgEntity
  );

  constructor(readonly data: RoomBrandBgSetEvent) {
    JsonSchemaValidator.assert(RoomBrandBgSetEventDTO.validation, data);
  }

  private static validationSchema() {
    return {
      type: "object",
      required: ["roomId", "brandBg"],
      properties: {
        roomId,
        brandBg: {
          instanceof: BrandBgEntity.name
        }
      }
    };
  }
}

interface RoomBrandBgSetEvent {
  roomId: RoomId;
  brandBg: BrandBgEntity;
}
